export const TABLE_DATE_COLUMN_RATION = 3
export const TABLE_DATE_COLUMN_SPAN = 3
